// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__24TDX","buttons":"PendingPaymentAlert_buttons__2GYUm"};